import React from 'react';
import PropTypes from 'prop-types';
import { ModuleNames } from '@purple/match-graphql-schema/lib/schema/common/types/SubscriptionModuleNameType/type';
import Table from '../../components/Table';
import Header from '../../components/Header';
import Segment from '../../components/Segment';
import buildDisplaySubscription, { getLocation, getDiversity, getCompetitors } from '../AdvancedAwarenessPage/utils';
import './styles.css';
import AMSubscriptionRow from './subscription-row';

class UnderstandingYourSubscription extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
    subscriptions: PropTypes.array,
    activeSubscriptions: PropTypes.array,
  };

  static defaultProps = {
    subscriptions: [],
  };

  renderRows() {
    const { subscriptions, activeSubscriptions } = this.props;

    return subscriptions.map((subscription) => {
      const currentSubscription = buildDisplaySubscription(subscription.node);
      const hasActiveSubscriptions = {
        connection: activeSubscriptions.includes(ModuleNames.CONNECTION),
        advancedAwareness: activeSubscriptions.includes(ModuleNames.ADVANCEDAWARENESS),
      };

      const rowProps = {
        location: getLocation(currentSubscription),
        diversity: getDiversity(currentSubscription),
        competitors: getCompetitors(currentSubscription),
        startDate: currentSubscription.startDate,
        endDate: currentSubscription.endDate,
        connection: currentSubscription.connection,
        majors: currentSubscription.majors,
        academicThreshold: currentSubscription.academicThreshold,
      };
      return (
        <AMSubscriptionRow
          {...rowProps}
          key={subscription.node.id}
          activeSubscriptions={hasActiveSubscriptions}
        />
      );
    });
  }

  render() {
    // eslint-disable-next-line max-len
    const message = 'Advanced Awareness is the opportunity to present relevant messages to students while Connection is the option to invite students to connect with your institution. Review the subscription details below for accuracy.';
    return (
      <Segment>
        <Header as="h2" size="medium">
          Your Advanced Awareness and Connection Subscriptions
        </Header>
        <Header.Subheader styleName="sub-header">
          {message}
        </Header.Subheader>
        <Table className="connections-table" data-cy="connections-table">
          <Table.Header styleName="tableHeader">
            <Table.Row>
              <Table.HeaderCell width="4">Audience</Table.HeaderCell>
              <Table.HeaderCell width="3">Competitors</Table.HeaderCell>
              <Table.HeaderCell width="2">Majors</Table.HeaderCell>
              <Table.HeaderCell width="2">Connection</Table.HeaderCell>
              <Table.HeaderCell width="3">Academic Threshold</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            { this.renderRows() }
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default UnderstandingYourSubscription;
